import { observer } from 'mobx-react';
import { FC, ReactElement, memo } from 'react';
import Skeleton from 'react-loading-skeleton';
import { previousOrderModalStore } from '../../store/previousOrderModalStore';
import { localeStore } from 'src/mobx/localesStore';

export const PreviousOrderModalProductNote: FC = memo(
  observer((): ReactElement | null => {
    const { loading, order } = previousOrderModalStore;

    if (!order?.notes) return null;

    return (
      <div className="previous-order-modal-product-note">
        <p className="previous-order-modal-product-note__title">{localeStore.t('Notes')}</p>
        {loading ? <Skeleton width={300} height={21.6} /> : <p className="previous-order-modal-product-note__note text-break">{order?.notes}</p>}
      </div>
    );
  })
);
